import React from 'react';
import { Center, Text } from '@gluestack-ui/themed';
const indicatorDotSizeVariantMap = {
    xs: '$3',
    sm: '$3.5',
    md: '$5',
    lg: '$6',
    xl: '$8',
};
const indicatorDotVariantColorMap = {
    success: '$success600',
    warning: '$yellow400',
    error: '$error500',
    neutral: '$gray800',
    primary: '$primary500',
};
export const IndicatorDot = ({ count, color, variant = 'primary', size = 'md', textProps, ...centerProps }) => {
    if (['xs', 'sm', 'md', 'lg', 'xl'].includes(size)) {
        size = indicatorDotSizeVariantMap[size];
    }
    size = size; // Hack to make TypeScript happy
    if (color === undefined) {
        color = indicatorDotVariantColorMap[variant];
    }
    // Make it easier to use without surrounding with conditionals everywhere
    if (count !== undefined && count === 0) {
        return null;
    }
    const fontColor = variant === 'warning' ? '$black' : '$white';
    return (React.createElement(Center, { bg: color, w: size, h: size, borderRadius: "$full", ...centerProps }, count && count > 0 ? (React.createElement(Text, { size: "lg", color: fontColor, ...textProps }, count)) : null));
};
